import type { QueryKey } from "@tanstack/react-query";

import type { GetLabAssetsQuery, LabAssetType } from "./labAssets.types";

/**
 * Query-key factory for the mfui-based lab-asset queries (LabAssetsTable).
 * Mirrors `storageQueryKeys` in storage.query.ts. Lives apart from
 * labAssets.query.ts (which imports the app's root queryClient from `@/index`,
 * and with it the whole route tree) so other features and their tests can
 * invalidate asset keys without loading the app.
 */
export const labAssetQueryKeys = {
  all: ["lab-assets"] as QueryKey,
  infiniteLists: ["lab-assets", "infinite-list"] as QueryKey,
  infiniteList: (query: GetLabAssetsQuery): QueryKey => [
    "lab-assets",
    "infinite-list",
    query,
  ],
  item: (uuid?: string): QueryKey => ["lab-assets", "item", { uuid }],
  activityLog: (uuid?: string): QueryKey => [
    "lab-assets",
    "activity-log",
    { uuid },
  ],
  meta: (assetType: LabAssetType): QueryKey => [
    "lab-assets",
    "meta",
    { assetType },
  ],
};
